import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import Vue from 'vue';
import SimpleLineIcons from "vue-simple-line";
import Toast from "vue-toastification";
import App from './App.vue';
import "./assets/styles/main.scss";
import router from './router';
import store from './store';

// helpers
import "./helpers/axios";
import "./helpers/prototypes";

Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 3,
  newestOnTop: true,
});
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.component("simple-line-icons", SimpleLineIcons);
Vue.component("Line-Loader", () =>
  import(
    /* webpackChunkName: "line-loader" */ "./components/loaders/line-loader.vue"
  )
);


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')